module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user_box",
    attrs: {
      "id": "user_box"
    }
  }, [_c('div', {
    staticClass: "bg_box"
  }), _vm._v(" "), _c('div', {
    staticClass: "user_top_box"
  }, [_c('div', {
    staticClass: "user_top_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.userData.userimg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user_top_nm"
  }, [_vm._v(_vm._s(_vm.userData.usernick))])]), _vm._v(" "), _c('div', {
    staticClass: "user_index_box"
  }, [_c('div', {
    staticClass: "user_index_list",
    on: {
      "click": function($event) {
        return _vm.gotogz()
      }
    }
  }, [_c('span', {
    staticClass: "user_index_list_l"
  }, [_vm._v("我的关注")]), _vm._v(" "), _c('var', {
    staticClass: "kf_icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "user_index_list",
    on: {
      "click": function($event) {
        return _vm.toastkefu()
      }
    }
  }, [_c('span', {
    staticClass: "user_index_list_l"
  }, [_vm._v("联系客服")]), _vm._v(" "), _c('var', {
    staticClass: "kf_icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "user_index_list",
    on: {
      "click": function($event) {
        return _vm.toastemail()
      }
    }
  }, [_c('span', {
    staticClass: "user_index_list_l"
  }, [_vm._v("商务合作")]), _vm._v(" "), _c('var', {
    staticClass: "kf_icon"
  })])]), _vm._v(" "), _c('tab-bar', {
    attrs: {
      "current-index": 1
    }
  }), _vm._v(" "), _c('van-popup', {
    staticClass: "servicePop",
    attrs: {
      "closeable": "",
      "close-on-click-overlay": false,
      "close-icon": "close"
    },
    model: {
      value: (_vm.servicePop),
      callback: function($$v) {
        _vm.servicePop = $$v
      },
      expression: "servicePop"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/ewm.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("添加官方微信客服")])]), _vm._v(" "), _c('van-popup', {
    staticClass: "emailPop",
    attrs: {
      "closeable": "",
      "close-on-click-overlay": false,
      "close-icon": "close"
    },
    model: {
      value: (_vm.emailPop),
      callback: function($$v) {
        _vm.emailPop = $$v
      },
      expression: "emailPop"
    }
  }, [_c('p', [_vm._v("邮箱：ksl2022@126.com")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1ef95161"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/page/user.vue
// module id = 692
// module chunks = 1